import React from "react";
import NaviBar from "../../../Component/Eng_Nav/Navbar";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";


import './Resume.css'

import Resume_Work from "./Resume_Work";
import Resume_Top from "./Resume_Top";
import Resume_Education from "./Resume_Education";
import Resume_Award from "./Resume_Award";
import Resume_Certificate from "./Resume_Certificate";

function Resume() {
  return (
    <>
      <NaviBar />
      <div style={{ background: "#66CDAA" , padding: "5%" }}>
        <Container>
          <Row>
            <Col md={7} style={{ marginTop: "5%", marginBottom: "5%" }}>
              <div className="text-center">
                <img src="images/profile2.jpeg" alt="Profile" className={"resume-image"}/>
              </div>
            </Col>

            <Col md={4} style={{ marginTop: "5%", marginBottom: "5%" }}>
              <Resume_Top></Resume_Top>
            </Col>
          </Row>

          {/* 하단 부 컨테이너 */}
          <Col style={{ background: "#66CDAA", padding: "5%" }}>
              <Resume_Work></Resume_Work>
              <Resume_Education></Resume_Education>
              <Resume_Award></Resume_Award>
              <Resume_Certificate></Resume_Certificate>
          </Col>
        </Container>
      </div>
    </>
  );
}

export default Resume;
